import ColoredBulletOption from './ColoredBulletOption';
import SharedCalendarViewState from '../data/store/schema/SharedCalendarViewState';
import getStore from '../data/store/store';
import { observer } from 'mobx-react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { updatePublishSelectedCalendar } from 'owa-calendar-sharing/lib/actions/calendarPublishing';
import CalendarPublishingInviteComponent from 'owa-calendar-sharing/lib/components/CalendarPublishingInviteComponent';
import CalendarsPublishedComponent from 'owa-calendar-sharing/lib/components/CalendarsPublishedComponent';
import 'owa-calendar-sharing/lib/orchestrators/loadCalendarPublishPermissionsOrchestrator';
import 'owa-calendar-sharing/lib/orchestrators/loadCalendarSharePermissionsOrchestrator';
import getCalendarPublishingStore from 'owa-calendar-sharing/lib/store/publishingStore';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import CalendarPublishingError from 'owa-calendar-sharing/lib/store/schema/CalendarPublishingError';
import initSharedCalendarsConfiguration from 'owa-shared-calendars-option/lib/orchestration/initSharedCalendarsConfiguration';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./PublishACalendarSection.scss');

export interface PublishACalendarSectionState {
    activeKey: string | number;
}

const CALENDAR_SHARING_TIME_DELAY = 0;

@observer
export default class PublishACalendarSection extends React.Component<
    {},
    PublishACalendarSectionState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            activeKey: null,
        };
    }

    render() {
        let { calendarsPublish } = getStore();
        let viewState = getCalendarPublishingStore().viewState;
        let currentlySelectedPublishingItemState = getCalendarPublishingStore().viewState
            ? getCalendarPublishingStore().viewState.selectedPublishingItemState
            : null;

        let activeKey = this.state.activeKey;

        if (!currentlySelectedPublishingItemState) {
            activeKey = null;
        }

        return (
            <div className={styles.shareACalendarWrapper}>
                <div className={styles.publishACalendarSectionMessage}>
                    {strings.options_publishedCalendars_PublishCalendarSectionMessage}
                </div>
                {/* Dropdown of Calendars to Publish */}
                <div className={styles.calendarPublishSection}>
                    <Dropdown
                        className={styles.dropdownContainer}
                        placeHolder={strings.options_sharedCalendars_SelectCalendarLabel}
                        selectedKey={activeKey != null ? activeKey : ''}
                        calloutProps={{
                            className: styles.shareACalendarCallout,
                        }}
                        onRenderOption={onRenderOption}
                        onChange={(
                            event: React.FormEvent<HTMLDivElement>,
                            item: IDropdownOption
                        ) => {
                            this.setState({
                                activeKey: item.key,
                            });

                            let calendar: SharedCalendarViewState = calendarsPublish[item.key];

                            // Added setTimeout with zero delay to avoid the JS error for maximum call stack exceeded
                            // when two modal box get displayed on top of each other while dropdown closes.
                            setTimeout(
                                () => updatePublishInfo(calendar.folderId),
                                CALENDAR_SHARING_TIME_DELAY
                            );
                        }}
                        options={getCalendarOptions(calendarsPublish)}
                    />

                    <CalendarPublishingInviteComponent />
                </div>

                {viewState.errorState &&
                    viewState.errorState.error ==
                        CalendarPublishingError.CreatePublishingPermissionFailure && (
                        <div className={styles.calendarPublishErrorSection}>
                            <Icon
                                className={styles.calendarPublishErrorIcon}
                                iconName={ControlIcons.ErrorBadge}
                            />
                            <span className={styles.calendarPublishErrorMessage}>
                                We couldn't publish your calendar at this time.
                                {/* {strings.options_publishedCalendars_PublishErrorMessage} */}
                            </span>
                        </div>
                    )}

                {/* Show all currently published calendars */}
                <CalendarsPublishedComponent onRetryInitialization={initSharedCalendars} />
            </div>
        );
    }
}

function initSharedCalendars() {
    initSharedCalendarsConfiguration();
}

function updatePublishInfo(folderId: string) {
    let viewState = getCalendarPublishingStore().viewState;
    let calendarPublished = viewState.publishedCalendarsMap.has(folderId);
    if (calendarPublished) {
        updatePublishSelectedCalendar(viewState.publishedCalendarsMap.get(folderId).itemStates[0]);
    }
}

const getCalendarOptions = (calendars: SharedCalendarViewState[]) => {
    let calendarsToShare = calendars.map((sharedCalendar, index) => {
        return {
            key: index,
            text: sharedCalendar.calendarName,
            data: {
                color: sharedCalendar.hexColorString,
            },
        };
    });
    return calendarsToShare;
};

/**
 * Custom renderer for dropdown as a colored bullet needs to be shown
 */
const onRenderOption = (option: IDropdownOption): JSX.Element => {
    return <ColoredBulletOption color={option.data.color} label={option.text} />;
};
